import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

const zh = {
  app_name:'评审系统',
  account:'登录账号',
  inputaccount:'请输入账号',
  inputpassword:'请输入密码',
  toLogin:'立即登录',
  accountNotEmpty:'账号不能为空',
  passwordNotEmpty:'密码不能为空',
  niandushenhe:'年度参赛作品审核',
  firstReview:'初审',
  secondReview:'复审',
  firstReviewUnstart:'初审未开始',
  firstReviewing:'初审中',
  firstReviewEnd:'初审已结束',
  firstReviewTime:'初审时间段：',
  groupNum:'小组编号',
  wordCount:'作品数量',
  reviewProcess:'评审进度',
  startReview:'开始评审',
  continueReview:'继续评审',
  seeDetail:'查看详情',
  secondReviewUnstart:'复审未开始',
  secondReviewing:'复审中',
  secondReviewEnd:'复审已结束',
  secondReviewTime:'复审时间段：',
  home:'首页',
  unReview:'未评审',
  unSubmit:'待提交',
  isSubmit:'已提交',
  tongguolv:'目前通过率为：',
  workName:'作品名称',
  type:'参赛类型',
  file:'参赛文件',
  result:'评审结果',
  tongguo:'通过',
  weitongguo:'未通过',
  pingyu:'评语',
  lev:'评审等级',
  op:'操作',
  edit:'修改评审',
  toPingshen:'去评审',
  detail:'查看详情',
  report:'制作报告',
  toScore:'评分',
  score:'分数：',
  inputScore:'请输入分数(百分制)',
  istongguo:'是否通过：',
  reviewLev:'评审等级：',
  inputPingyu:'请输入评语',
  cancel:'取 消',
  cancel2:'取消',
  yes:'确定',
  workDetail:'作品详情',
  baseInfo:'基本信息',
  author:'作者',
  tel:'电话',
  mail:'邮箱',
  cardType:'证件类型',
  cardCode:'证件号',
  panlink:'网盘链接',
  workintro:'作品简介',
  workFile:'作品文件',
  loading:'加载中...',
  empty:'暂无数据',
  submitConfirm:'提交后将不能修改，确认提交吗？',
  exit:'退出',
  langBtn:'EN',
  
  
  //elementUI
  ...zhLocale
}
export default zh
